// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".ContractorInfo-module__contractorInfo--LB8L0 li{padding:.45rem .75rem !important}", "",{"version":3,"sources":["webpack://./src/view/components/forms/settings/ContractorCreateForm/components/ContractorInfo.module.scss"],"names":[],"mappings":"AACE,iDACE,gCAAA","sourcesContent":[".contractorInfo {\n  li {\n    padding: 0.45rem 0.75rem !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"contractorInfo": "ContractorInfo-module__contractorInfo--LB8L0"
};
export default ___CSS_LOADER_EXPORT___;
